import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as diagnosticActions from '../actions/diagnostic.actions';
import { Definition, Diagnostic } from '../types/diagnostic';

declare module 'react-redux' {
  interface DefaultRootState {
    diagnostic: DiagnosticState;
  }
}

export interface DiagnosticState {
  primaryDefinitions: Definition[];
  definitions: Definition[];
  diagnostics: Diagnostic[];
  currentDiagnosticIndex: number;
}

const initialStateFactory = (): DiagnosticState => {
  return {
    primaryDefinitions: [],
    definitions: [],
    diagnostics: [],
    currentDiagnosticIndex: -1,
  };
};

export default reducer(
  initialStateFactory(),
  on(
    diagnosticActions.setDefinitions,
    (state, { definitions, primaryDefinitions }): DiagnosticState => ({
      ...state,
      definitions,
      primaryDefinitions,
    }),
  ),
  on(
    diagnosticActions.setDiagnostics,
    (state, { diagnostics }): DiagnosticState => {
      return {
        ...state,
        diagnostics,
        currentDiagnosticIndex: 0,
      };
    },
  ),
  on(
    diagnosticActions.setDiagnosticIndex,
    (state, { diagnosticIndex }): DiagnosticState => {
      return {
        ...state,
        currentDiagnosticIndex: diagnosticIndex,
      };
    },
  ),
  on(diagnosticActions.save, (state, { diagnostic }): DiagnosticState => {
    const diagnostics = state.diagnostics.slice();
    const index = diagnostics.findIndex(({ id }) => id === diagnostic.id);

    if (index > -1) {
      diagnostics.splice(index, 1, diagnostic);
    } else {
      diagnostics.unshift(diagnostic);
    }

    return {
      ...state,
      diagnostics,
      currentDiagnosticIndex: index > -1 ? index : 0,
    };
  }),
  on(ecgActions.clean, () => initialStateFactory()),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { diagnostic } }): DiagnosticState => {
      if (!diagnostic) {
        return state;
      }
      return { ...state, ...diagnostic };
    },
  ),
);
